// <copyright file="DleRecordTypeDataSource.tsx">
// © 2024 Florida Department of Transportation
//
// The copyright to the computer program(s) and source code herein is
// the property of the Florida Department of Transportation.
// The program(s) and source code may be used and/or copied only with the
// written permission of the Florida Department of Transportation or
// in accordance with the terms and conditions stipulated in the
// agreement/contract under which the program(s) and source code have
// been supplied.
// </copyright>

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import React from "react";
import styles from "src/components/DataLakeExplorer/DleRecordTypeDataSource.module.css";
import type { FC, useState as _useState } from "react";
import type { DataSource } from "src/components/DataLakeExplorer/DleRecordType";


// Properties to initialize this component
interface DleRecordTypeDataSourceProps {
    useState?: typeof _useState; // optional hook override (for tests)
    recordType: string;
    dataInfo: DataSource[];
}

// Info/error message popup
const toast = React.createRef<Toast>();

/**
 * DLE record type data source component
 * @param props Component props
 * @returns The component
 */
const DleRecordTypeDataSource: FC<DleRecordTypeDataSourceProps> = (
    props: DleRecordTypeDataSourceProps
) => (
    <div
        className={styles.DleRecordTypeDataSource}
        data-testid="DleRecordTypeDataSource"
    >
    <Toast ref={toast} />
    <DataTable value={props.dataInfo} showGridlines>
    <Column field="Agency" header="Agency" />
    <Column field="ProducerName" header="Producer Name" />
    <Column field="HostType" header="Host Type" />
    <Column field="RawType" header="Raw Type" />
    <Column field="IngestionMethod" header="Ingestion Method" />
    <Column field="IngestionFreq" header="Ingestion Frequency" />
    <Column field="SchemaCreated" header="Schema Created" />
    <Column field="PointOfContact" header="Point of Contact" />
    <Column field="CuratedRecordTypes" header="Curated Record Types" />
    <Column field="PartitionKeyFormat" header="Partition Key Format" />
    <Column field="ExamplePartitionKey" header="Example Partition Key" style={{overflowWrap: 'anywhere'}} />
    </DataTable>
    </div>)

export default DleRecordTypeDataSource;
